interface sizePresets {
    [key: string]: number;
}

interface sizeOverwrite {
    [key: string]: string;
}


const imageSizeOverwrites: sizeOverwrite = {
    "nvbsodr": "small",
    "nvbsbib": "small",
    "nvbshov": "small",
    "nvbsbti": "small",
    "nvbsdrb": "small",
};

const ImageSizePresets: sizePresets = {
    'default': 200,
    'small': 100,
}

const DetailSizePresets: sizePresets = {
    'default': 300,
    'small': 150,
}

const GetThumbnailSize = (category: string): number => {
    const sizeKey = imageSizeOverwrites[category] || 'default';
    return ImageSizePresets[sizeKey];
}

const GetDetailSize = (category: string): number => {
    const sizeKey = imageSizeOverwrites[category] || 'default';
    return DetailSizePresets[sizeKey];
}

export { ImageSizePresets, GetThumbnailSize, DetailSizePresets, GetDetailSize };